import { render, staticRenderFns } from "./ChatBody.vue?vue&type=template&id=416fe7b4&scoped=true"
import script from "./ChatBody.vue?vue&type=script&lang=js"
export * from "./ChatBody.vue?vue&type=script&lang=js"
import style0 from "./ChatBody.vue?vue&type=style&index=0&id=416fe7b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416fe7b4",
  null
  
)

export default component.exports